import dayjs from 'lib/dayjs'
import { Box, Typography } from '@mui/material'
import { TRoomInformationProps } from './RoomInformation.types'
import { useRoomInformationLogic } from './RoomInformation.logic'
import styles from './RoomInformation.styles.module.scss'

const RoomInformation: React.FC<TRoomInformationProps> = (props) => {
  const { showDate, surgery, onClick } = props
  const logic = useRoomInformationLogic(props)

  return (
    <Box
      className={`${styles.room} ${logic.isCancelled ? styles.cancelled : ''}`}
      data-testid="room-number"
      style={{ cursor: logic.cursor, backgroundColor: logic.statusColor }}
      {...(onClick &&
        logic.flags.enablePatientStatus &&
        logic.isNurseOrNurseAdmin && {
          onClick: (e: React.MouseEvent) => {
            if (logic.isCancelled) {
              return
            }
            e.stopPropagation()
            onClick({
              show: true,
              surgery: surgery,
            })
          },
        })}
    >
      {logic.isManuallyAdded ? (
        <Box className={styles.manuallyAdded}>
          <Typography className={styles.label}>M</Typography>
        </Box>
      ) : null}

      {logic.flags.enablePatientStatus ? (
        logic.room ? (
          <>
            <Typography className={styles.status}>{logic.status}</Typography>
            <Typography className={styles.number} style={logic.roomNumberStyle}>
              {logic.room.toUpperCase()}
            </Typography>
          </>
        ) : (
          <Typography className={styles.status}>{logic.status}</Typography>
        )
      ) : (
        <>
          <Typography className={styles.title}>ROOM</Typography>
          <Typography className={styles.number} style={logic.roomNumberStyle}>
            {logic.room}
          </Typography>
        </>
      )}

      {logic.timeString && logic.showSurgeryTime && !logic.isCancelled ? (
        <Typography className={styles.timeText}>{logic.timeString}</Typography>
      ) : (
        <Box className={styles.timePlaceholder} />
      )}

      {showDate && logic.earliestDateTime && (
        <Typography className={styles.date}>
          {dayjs(logic.earliestDateTime).format('MM/DD/YYYY')}
        </Typography>
      )}
    </Box>
  )
}

export default RoomInformation
